import React from "react";
import { v4 as uuidv4 } from "uuid";
// var moment = require("moment");

export const uniqueWorkFlowId = (wf_name) => {
  let workflowName = (wf_name?.length == 6) ? wf_name : wf_name.padEnd(4, getRandomCharacter(4-wf_name.length).toUpperCase()).substr(0, 4);
  let result = `${workflowName.toUpperCase()}${uuidv4()
    .replace(/-/g, "")
    .substring(0, 12)
    .toUpperCase()}`;
  return result.toUpperCase();
};


function getRandomCharacter(length) {
  let result = '';
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  const charactersLength = characters.length;
  let counter = 0;
  while (counter < length) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
    counter += 1;
  }
  return result;
}

